"use client";

import { motion } from "framer-motion";
import { GetEarlyAccessButton } from "@/components/ui/buttons";
import { ease } from "@/lib/motion";

export function FinalCta() {
  return (
    <section className="relative overflow-x-clip py-20 sm:py-40">
      {/* ambient glow, centred on the line. The section clips only on the x
          axis (a phone would otherwise scroll sideways into the blur) and lets
          it spill above and below, so the glow fades out on its own rather
          than ending on the section's edge. */}
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[90vmin] w-[120vmin] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-60 blur-[110px]"
        style={{
          background: "radial-gradient(ellipse at center, var(--accent-soft), transparent 68%)",
        }}
      />
      <div className="relative mx-auto max-w-[90rem] px-5 text-center sm:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.9, ease }}
          className="mx-auto max-w-4xl font-serif text-[clamp(2.2rem,6vw,4.5rem)] font-light leading-[1.05] tracking-[-0.02em]"
        >
          Cost-effective inference for every leading open model.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.9, ease, delay: 0.2 }}
          className="mt-12 flex flex-wrap items-center justify-center gap-4"
        >
          <GetEarlyAccessButton className="px-7 py-3.5 text-base" />
        </motion.div>
      </div>
    </section>
  );
}
